import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  dangerBox: {
    marginBottom: theme.spacing(0),
    marginTop: theme.spacing(-2),
    backgroundColor: '#fad9d161',
    borderRadius: '8px',
    border: 'solid 1px #FAD9D1',
    boxShadow: 'none',
    padding: theme.spacing(1.5),
    margin: '5px 0 0',
    display: 'flex',
    alignItems: 'center',
    '@media(max-width: 550px)': {
      flexDirection: 'column',
    },
  },
  dangerText: {
    fontSize: '13px',
    lineHeight: '25px',
    paddingLeft: '10px',
    textAlign: 'justify',
    COLOR: '#0C0E10',
    '@media(max-width: 550px)': {
      paddingLeft: '0',
    },
  },
  dangerLink: {
    color: '#ff5500',
  },
}));
